// This icon file is generated automatically.
var PArrowleftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.63 5.4H2.47L7.95.67a.12.12 0 00-.08-.22H6.5a.25.25 0 00-.16.06L.43 5.62a.5.5 0 000 .76l5.93 5.15c.02.02.05.03.08.03h1.43c.12 0 .17-.14.08-.22L2.48 6.6h9.14c.07 0 .13-.05.13-.12v-.94a.13.13 0 00-.13-.12z", "fill-rule": "nonzero" } }] }, "name": "p-arrowleft", "theme": "outlined" };
export default PArrowleftOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PArrowLeftOutlined.js
// module id = 3217
// module chunks = 0